import { InputTags } from "@/03-presenters/components/ui/inputTag";
import { useState } from "react";
import { useTableStore } from "../TableStoreProvider";
export const INPUT_TAG_JOIN_KEY = "input_tag_join_key";
export default function InputTagComp({
  filterKey
}: {
  filterKey: string;
}) {
  const tableStore = useTableStore();
  const filters = tableStore(state => state.filters);
  const updateFilter = tableStore(state => state.updateFilter);
  const setPageIndex = tableStore(state => state.setPageIndex);
  const filterValue = filters.find(filter => filter.filterKey === filterKey)?.value;
  const [includeValueRaw, excludeValueRaw] = filterValue ? filterValue.split(INPUT_TAG_JOIN_KEY) : ["", ""];
  const includeValue = includeValueRaw?.split(",")?.filter(Boolean);
  const excludeValue = excludeValueRaw?.split(",")?.filter(Boolean);
  function setIncludeValue(value: string[]) {
    updateFilter(filterKey, value.join(",") + INPUT_TAG_JOIN_KEY + (excludeValue || []).join(","));
    setPageIndex(0);
  }
  function setExcludeValue(value: string[]) {
    updateFilter(filterKey, includeValue.join(",") + INPUT_TAG_JOIN_KEY + value.join(","));
    setPageIndex(0);
  }
  return <div className="flex w-full items-center justify-between gap-8" data-sentry-component="InputTagComp" data-sentry-source-file="InputTagComp.tsx">
      <div className="flex flex-1 items-center gap-2">
        <span className="text-nowrap text-sm text-gray-7">
          包含({includeValue.length})
        </span>
        <InputTags value={includeValue} onChange={value => {
        setIncludeValue(value);
      }} className=" w-full" data-sentry-element="InputTags" data-sentry-source-file="InputTagComp.tsx" />
      </div>
      <div className="flex flex-1 items-center gap-2">
        <span className="text-nowrap text-sm text-[#666666]">
          排除({excludeValue.length})
        </span>
        <InputTags value={excludeValue} onChange={value => {
        setExcludeValue(value);
      }} className="w-full" data-sentry-element="InputTags" data-sentry-source-file="InputTagComp.tsx" />
      </div>
    </div>;
}